module.exports = __webpack_public_path__ + "static/wedding-2-32c98ffeeb9f55215868c63c312aab9a.png";